import { alphaRegex, emailRegex } from '@buy-viasat/utils';
import { Country } from '@buy-viasat/types/build/bv';
import { phoneNumberRegex } from '@buy-viasat/utils';

export function validateName(name: string): boolean {
  return !!name && alphaRegex.test(name.trim());
}

export function validateEmail(email: string): boolean {
  return !!email && emailRegex.test(email.trim());
}

export function validatePhone(phone: string): boolean {
  const regex = phoneNumberRegex[Country.US];
  return !!phone && regex.test(phone.trim());
}
